import {
  gqlMutate,
  gqlQuery,
  mutationMockHandler,
} from '@hapana/shared/web/services/requests.service'
import {
  ACTIVE_EXPORT_REQUEST_RESPONSE_MOCK,
  ACTIVE_EXPORT_RESPONSE_MOCK,
  CREATE_EXPORT_REQUEST_MOCK,
  DELETE_EXPORT_REQUEST_MOCK,
} from '_mocks/exports.mock'

import { activeExports } from './graphql/exports.queries'
import * as mutations from './graphql/exports.mutations'
const ACTIVE_EXPORT_REQUESTS = 'ACTIVE_EXPORT_REQUESTS'

export const createExportRequest = ({ exportRequest, exportName }) =>
  gqlMutate({
    mutation: mutations.exportRequest,
    variables: {
      exportRequest,
      exportName,
    },
    options: {
      isV1: false,
    },
  })

createExportRequest.mockHandler = mutationMockHandler(mutations.exportRequest, {
  createExportRequest: CREATE_EXPORT_REQUEST_MOCK,
})

export const getActiveExportRequests = gqlQuery({
  query: activeExports,
  key: ACTIVE_EXPORT_REQUESTS,
  mockResponse: ACTIVE_EXPORT_RESPONSE_MOCK,
  options: {
    isV1: false,
  },
})

export const activeExportRequest = (requestId) =>
  gqlMutate({
    mutation: mutations.activeExportRequest,
    variables: {
      requestId,
    },
    options: {
      isV1: false,
    },
  })

activeExportRequest.mockHandler = mutationMockHandler(mutations.activeExportRequest, {
  activeExportRequest: ACTIVE_EXPORT_REQUEST_RESPONSE_MOCK,
})

export const clearExportRequestHistory = () =>
  gqlMutate({
    mutation: mutations.clearExportRequestHistory,
    variables: {},
    options: {
      isV1: false,
    },
  })

export const deleteExportRequest = (requestId) =>
  gqlMutate({
    mutation: mutations.deleteExportRequest,
    variables: {
      requestId,
    },
    options: {
      isV1: false,
    },
  })

deleteExportRequest.mockHandler = mutationMockHandler(mutations.deleteExportRequest, {
  deleteExportRequest: DELETE_EXPORT_REQUEST_MOCK,
})
